export default "__VITE_ASSET__BytmhWuo__"